module.exports = __webpack_public_path__ + "img/img13.5d1dd3a5.svg";